import * as Yup from 'yup';
import YesNoButton from '../YesNoButton/YesNoButton';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  value: any;
  error: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const HasChildren = ({ value, error, setFieldValue, updateSchema }: Props) => {
  const intl = useIntl();

  useEffect(() => {
    const hasChildrenSchema = {
      hasChildren: Yup.boolean().required(
        intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
      )
    };
    updateSchema(hasChildrenSchema);
  }, []);

  return (
    <YesNoButton
      id="hasChildren"
      name="hasChildren"
      label={intl.formatMessage({ ...messages.hasChildren })}
      value={value}
      onChange={(value: any) => setFieldValue('hasChildren', value)}
      error={error}
    />
  );
};

export default HasChildren;
